<template>
  <div>
    <BreadCrumb PageTitle="Wholesale Orders List" />
    <MerchantOrdersList />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import MerchantOrdersList from "../../components/Wholesale/MerchantOrdersList.vue";

export default defineComponent({
  name: "MerchantOrdersListPage",
  components: {
    BreadCrumb,
    MerchantOrdersList,
  },
});
</script>